import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout.vue';
import AuthLayout from '@/pages/Dashboard/Pages/AuthLayout.vue';

// Dashboard pages
// import Dashboard from '@/pages/Dashboard/DashboardData.vue';
import Dashboard from '@/pages/Dashboard/DashboardWrapper.vue';
import TodayDashboard from '@/pages/Dashboard/TodayDashboard.vue';


// Example pages
import UserProfile from '@/pages/Dashboard/Examples/UserProfile.vue';
// Role Management
import ListRolePage from '@/pages/Dashboard/Examples/RoleManagement/ListRolePage.vue';
import AddRolePage from '@/pages/Dashboard/Examples/RoleManagement/AddRolePage.vue';
import EditRolePage from '@/pages/Dashboard/Examples/RoleManagement/EditRolePage.vue';
// User Management
import ListUserPage from '@/pages/Dashboard/Examples/UserManagement/ListUserPage.vue';
// import AddUserPage from "@/pages/Dashboard/Examples/UserManagement/AddUserPage.vue";
import ViewUserPage from '@/pages/Dashboard/Examples/UserManagement/ViewUserPage.vue';
import EditUserPage from '@/pages/Dashboard/Examples/UserManagement/EditUserPage.vue';
// Category Management
import ListCategoryPage from '@/pages/Dashboard/Examples/CategoryManagement/ListCategoryPage.vue';
import AddCategoryPage from '@/pages/Dashboard/Examples/CategoryManagement/AddCategoryPage.vue';
import EditCategoryPage from '@/pages/Dashboard/Examples/CategoryManagement/EditCategoryPage.vue';
// Tag Management
import ListTagPage from '@/pages/Dashboard/Examples/TagManagement/ListTagPage.vue';
import AddTagPage from '@/pages/Dashboard/Examples/TagManagement/AddTagPage.vue';
import EditTagPage from '@/pages/Dashboard/Examples/TagManagement/EditTagPage';
// Item Management
import ListItemPage from '@/pages/Dashboard/Examples/ItemManagement/ListItemPage.vue';
import AddItemPage from '@/pages/Dashboard/Examples/ItemManagement/AddItemPage.vue';
import EditItemPage from '@/pages/Dashboard/Examples/ItemManagement/EditItemPage';

// Pages
import User from '@/pages/Dashboard/Pages/UserProfile.vue';
import TimeLine from '@/pages/Dashboard/Pages/TimeLinePage.vue';
import Login from '@/pages/Dashboard/Pages/Login.vue';
import LabourerInfoSearch from '@/pages/Dashboard/Pages/LabourerInfoSearchPage.vue';
import Register from '@/pages/Dashboard/Pages/Register.vue';
import Lock from '@/pages/Dashboard/Pages/Lock.vue';

// Stations
import  ListStationPage from '@/pages/settings/stations/ListStationPage.vue';
import  EditStationPage from '@/pages/settings/stations/EditStationPage.vue';
import  AddStationPage from '@/pages/settings/stations/AddStationPage.vue';
import  ViewStationPage from '@/pages/settings/stations/ViewStationPage.vue';
// workplaces
import ListWorkplacePage from '../pages/settings/workplaces/ListWorkplacePage';
import AddWorkplacePage from '../pages/settings/workplaces/AddWorkplacePage';
import EditWorkplacePage from '../pages/settings/workplaces/EditWorkplacePage';
import ViewWorkplacePage from '../pages/settings/workplaces/ViewWorkplacePage';


// Components pages
import Buttons from '@/pages/Dashboard/Components/Buttons.vue';
import GridSystem from '@/pages/Dashboard/Components/GridSystem.vue';
import Panels from '@/pages/Dashboard/Components/Panels.vue';
import SweetAlert from '@/pages/Dashboard/Components/SweetAlert.vue';
import Notifications from '@/pages/Dashboard/Components/Notifications.vue';
import Icons from '@/pages/Dashboard/Components/Icons.vue';
import Typography from '@/pages/Dashboard/Components/Typography.vue';



// Maps pages
import GoogleMaps from '@/pages/Dashboard/Maps/GoogleMaps.vue';
import FullScreenMap from '@/pages/Dashboard/Maps/FullScreenMap.vue';
import VectorMaps from '@/pages/Dashboard/Maps/VectorMaps.vue';

// Calendar
import Calendar from '@/pages/Dashboard/Calendar.vue';
// Charts
import Charts from '@/pages/Dashboard/Charts.vue';
import Widgets from '@/pages/Dashboard/Widgets.vue';


// import middleware
import auth from '@/middleware/auth';
import guest from '@/middleware/guest';
import ListDepartmentPage from '../pages/settings/departments/ListDepartmentPage';
import AddDepartmentPage from '../pages/settings/departments/AddDepartmentPage';
import EditDepartmentPage from '../pages/settings/departments/EditDepartmentPage';
import ViewDepartmentPage from '../pages/settings/departments/ViewDepartmentPage';
import ListPortPage from '../pages/settings/ports/ListPortPage';
import AddPortPage from '../pages/settings/ports/AddPortPage';
import EditPortPage from '../pages/settings/ports/EditPortPage';
import ViewPortPage from '../pages/settings/ports/ViewPortPage';

// Activity
import ListActivityPage from '../pages/settings/activities/ListActivityPage';
import AddActivityPage from '../pages/settings/activities/AddActivityPage';
import EditActivityPage from '../pages/settings/activities/EditActivityPage.vue';
import ViewActivityPage from '../pages/settings/activities/ViewActivityPage';

import ListActivityTariffPage from '../pages/settings/activity_tariffs/ListActivityTariffPage';

// Guidance
import ListGuidancePage from '../pages/settings/guidances/ListGuidancePage';
import ManageGuidancePage from '../pages/settings/guidances/ManageGuidancePage';
import ManageGuidanceShiftPage from '../pages/settings/guidances/ManageGuidanceShiftPage';
import ManageGuidanceWorkItemtPage from '../pages/settings/guidances/workItems/ManageGuidanceWorkItemPage.vue';
import ActionGuidanceWorkItemtPage from '../pages/settings/guidances/workItems/ActionGuidanceWorkItemPage.vue';
import ManageLabourerAssignmentPage from '../pages/settings/guidances/ManageLabourerAssignmentPage';
import AddGuidancePage from '../pages/settings/guidances/AddGuidancePage';
import EditGuidancePage from '../pages/settings/guidances/EditGuidancePage';
import ViewGuidancePage from '../pages/settings/guidances/ViewGuidancePage';

import AddApprovalFormWizard from '../pages/settings/guidances/Wizard';


// Guidance
import ListActivityGuidancePage from '../pages/settings/activityGuidances/ListActivityGuidancePage';
import AddActivityGuidancePage from '../pages/settings/activityGuidances/AddActivityGuidancePage';
import EditActivityGuidancePage from '../pages/settings/activityGuidances/EditActivityGuidancePage';
// Activity Labourer Workplace
import ListActivityLabourerWorkplacePage from '../pages/settings/activityLabourerWorkplaces/ListActivityLabourerWorkplacePage';
import AddActivityLabourerWorkplacePage from '../pages/settings/activityLabourerWorkplaces/AddActivityLabourerWorkplacePage';
import EditActivityLabourerWorkplacePage from '../pages/settings/activityLabourerWorkplaces/EditActivityLabourerWorkplacePage';
import ViewActivityLabourerWorkplacePage from '../pages/settings/activityLabourerWorkplaces/ViewActivityLabourerWorkplacePage';
// Guidance
import ListGuidanceWorkplacePage from '../pages/settings/guidanceWorkplace/ListGuidanceWorkplacePage';
import AddGuidanceWorkplacePage from '../pages/settings/guidanceWorkplace/AddGuidanceWorkplacePage';
import EditGuidanceWorkplacePage from '../pages/settings/guidanceWorkplace/EditGuidanceWorkplacePage';
import ViewGuidanceWorkplacePage from '../pages/settings/guidanceWorkplace/EditGuidanceWorkplacePage';


// tariff
import AddTariffPage from '../pages/settings/tariffs/AddTariffPage';
import EditTariffPage from '../pages/settings/tariffs/EditTariffPage';
import ListTariffPage from '../pages/settings/tariffs/ListTariffPage';
import ViewTariffPage from '../pages/settings/tariffs/ViewTariffPage';

import AddLabourerPaymentPage from '../pages/vendors/LabourerPayments/AddLabourerPaymentPage';
import EditLabourerPaymentPage from '../pages/vendors/LabourerPayments/EditLabourerPaymentPage';
import ListLabourerPaymentPage from '../pages/vendors/LabourerPayments/ListLabourerPaymentPage';
import ViewLabourerPaymentPage from '../pages/vendors/LabourerPayments/ViewLabourerPaymentPage';

import AddLabourerPaymentItemPage from '../pages/vendors/LabourerPaymentItems/AddLabourerPaymentItemPage';
import EditLabourerPaymentItemPage from '../pages/vendors/LabourerPaymentItems/EditLabourerPaymentItemPage';
import ListLabourerPaymentItemPage from '../pages/vendors/LabourerPaymentItems/ListLabourerPaymentItemPage';
import ViewLabourerPaymentItemPage from '../pages/vendors/LabourerPaymentItems/ViewLabourerPaymentItemPage';

import LabourerPayments from '../pages/vendors/LabourerPayments/LabourerPayment.vue';
import LabourerPaymentsReady from '../pages/vendors/LabourerPayments/LabourerPayment.vue';

// works
import ListWorkPage from '../pages/employer/works/ListWorkPage';
import AddWorkPage from '../pages/employer/works/AddWorkPage';
import EditWorkPage from '../pages/employer/works/EditWorkPage';
import ViewWorkPage from '../pages/employer/works/ViewWorkPage';

// work Items
import ListWorkItemPage from '../pages/employer/work_items/ListWorkItemPage';
import AddWorkItemPage from '../pages/employer/work_items/AddWorkItemPage';
import EditWorkItemPage from '../pages/employer/work_items/EditWorkItemPage';

// work Details
import ListWorkDetailPage from '../pages/employer/work_details/ListWorkDetailPage';
import AddWorkDetailPage from '../pages/employer/work_details/AddWorkDetailPage';
import EditWorkDetailPage from '../pages/employer/work_details/EditWorkDetailPage';
// shifts

import AddShiftPage from '../pages/settings/shifts/AddShiftPage.vue';
import EditShiftPage from '../pages/settings/shifts/EditShiftPage.vue';
import ListShiftPage from '../pages/settings/shifts/ListShiftPage.vue';
import ViewShiftPage from '../pages/settings/shifts/ViewShiftPage.vue';

// poassword Reset
import PasswordReset from '../pages/general/passwordReset.vue';
import Reset from '../pages/general/Reset.vue';
import ViewRolePage from '../pages/Dashboard/Examples/RoleManagement/ViewRolePage';
// assign Permissions
import AssignPermissionPage from '../pages/Dashboard/Examples/RoleManagement/AssignPermissionPage';

// permissins
import AddPermissionPage from '../pages/settings/permissions/AddPermissionPage';
import EditPermissionPage from '../pages/settings/permissions/EditPermissionPage';
import ListPermissionPage from '../pages/settings/permissions/ListPermissionPage';

import AddVendorPage from '../pages/vendors/vendors/AddVendorPage';
import EditVendorPage from '../pages/vendors/vendors/EditVendorPage';
import ListVendorPage from '../pages/vendors/vendors/ListVendorPage';
import ViewVendorPage from '../pages/vendors/vendors/NewViewVendorPage.vue';

// vendors
//Labourers
import AddLabourerPage from '../pages/vendors/labourers/AddLabourerPage';
import EditLabourerPage from '../pages/vendors/labourers/EditLabourerPage';
import ListLabourerPage from '../pages/vendors/labourers/ListLabourerPage';
import UploadLabourerPage from '../pages/vendors/labourers/UploadBulkLabourerPage.vue';
import ListLabourerTerminatedPage from '../pages/vendors/labourers/ListLabourerTerminatedPage.vue';
import ViewLabourerPage from '../pages/vendors/labourers/ViewLabourerPage';
import ViewLabourerTakeonPage from '../pages/vendors/labourers/ViewLabourerTakeonPage';
import LabourerReadinessDashboard from '../pages/vendors/labourers/LabourerReadinessDashboard.vue';

import AddLabourerAttendancePage from '../pages/vendors/labourerAttendances/AddLabourerAttendancePage';
import EditLabourerAttendancePage from '../pages/vendors/labourerAttendances/EditLabourerAttendancePage';
import ListLabourerAttendancePage from '../pages/vendors/labourerAttendances/ListLabourerAttendancePage';
import ViewLabourerAttendancePage from '../pages/vendors/labourerAttendances/ViewLabourerAttendancePage';

import ListLabourerSchedulePage from '../pages/vendors/labourerSchedules/ListLabourerSchedulePage';
import ViewLabourerSchedulePage from '../pages/vendors/labourerSchedules/ViewLabourerSchedulePage';
import ApproveLabourerSchedulePage from '../pages/vendors/labourerSchedules/ApproveLabourerSchedulePage';
import SupervisorCheckinCheckout from '../pages/vendors/labourerSchedules/SupervisorCheckInOut.vue';

import LabourerShiftReportPage from '../pages/vendors/labourerSchedules/LabourerShiftReport.vue';

// zones
import AddZonePage from '../pages/settings/zones/AddZonePage';
import EditZonePage from '../pages/settings/zones/EditZonePage';
import ListZonePage from '../pages/settings/zones/ListZonePage';

// regions
import AddRegionPage from '../pages/settings/regions/AddRegionPage';
import EditRegionPage from '../pages/settings/regions/EditRegionPage';
import ListRegionPage from '../pages/settings/regions/ListRegionPage';

// religions

import AddReligionPage from '../pages/settings/religions/AddReligionPage';
import EditReligionPage from '../pages/settings/religions/EditReligionPage';
import ListReligionPage from '../pages/settings/religions/ListReligionPage';


// district types
import AddDistrictTypePage from '../pages/settings/districtTypes/AddDistrictTypePage';
import EditDistrictTypePage from '../pages/settings/districtTypes/EditDistrictTypePage';
import ListDistrictTypePage from '../pages/settings/districtTypes/ListDistrictTypePage';

// districts
import AddDistrictPage from '../pages/settings/districts/AddDistrictPage';
import EditDistrictPage from '../pages/settings/districts/EditDistrictPage';
import ListDistrictPage from '../pages/settings/districts/ListDistrictPage';

// wards
import AddWardPage from '../pages/settings/wards/AddWardPage';
import EditWardPage from '../pages/settings/wards/EditWardPage';
import ListWardPage from '../pages/settings/wards/ListWardPage';

// villages

import AddVillagePage from '../pages/settings/villages/AddVillagePage';
import EditVillagePage from '../pages/settings/villages/EditVillagePage';
import ListVillagePage from '../pages/settings/villages/ListVillagePage';

// neighborhoods

import AddNeighborhoodPage from '../pages/settings/neighborhoods/AddNeighborhoodPage';
import EditNeighborhoodPage from '../pages/settings/neighborhoods/EditNeighborhoodPage';
import ListNeighborhoodPage from '../pages/settings/neighborhoods/ListNeighborhoodPage';

// ExamCycle
import AddexamCyclePage from '../pages/settings/examCycles/AddexamCyclePage';
import EditexamCylePage from '../pages/settings/examCycles/EditexamCylePage';
import ListexamCyclePage from '../pages/settings/examCycles/ListexamCyclePage';

// skills
import AddSkillPage from '../pages/settings/skills/AddSkillPage';
import EditSkillPage from '../pages/settings/skills/EditSkillPage';
import ListSkillPage from '../pages/settings/skills/ListSkillPage';
import ViewSkillPage from '../pages/settings/skills/ViewSkillPage';

// skills Category
import AddSkillCategoryPage from '../pages/settings/skillCategory/AddSkillCategoryPage';
import EditSkillCategoryPage from '../pages/settings/skillCategory/EditSkillCategoryPage';
import ListSkillCategoryPage from '../pages/settings/skillCategory/ListSkillCategoryPage';
import AddLevelPage from '../pages/settings/levels/AddLevelPage';
import EditLevelPage from '../pages/settings/levels/EditLevelPage';
import ListLevelPage from '../pages/settings/levels/ListLevelPage';

// Attachment Types
import AddAttachmentTypesPage from '../pages/settings/attachmentTypes/AddAttachmentTypesPage';
import EditAttachmentTypesPage from '../pages/settings/attachmentTypes/EditAttachmentTypesPage';
import ListAttachmentTypePage from '../pages/settings/attachmentTypes/ListAttachmentTypePage';

// Employees
import AddEmployeePage from '../pages/vendors/employees/AddEmployeePage';
import EditEmployeePage from '../pages/vendors/employees/EditEmployeePage';
import ListEmployeePage from '../pages/vendors/employees/ListEmployeePage';
import ViewEmployeePage from '../pages/vendors/employees/ViewEmployeePage';

// Institution
import AddInstitutionPage from '../pages/employer/institutions/AddInstitutionPage';
import EditInstitutionPage from '../pages/employer/institutions/EditInstitutionPage';
import ListInstitutionPage from '../pages/employer/institutions/ListInstitutionPage';
import ViewInstitutionPage from '../pages/employer/institutions/ViewInstitutionPage';

// staff
import AddStaffPage from '../pages/employer/staffs/AddStaffPage';
import EditStaffPage from '../pages/employer/staffs/EditStaffPage';
import ListStaffPage from '../pages/employer/staffs/ListStaffPage';
import ViewStaffPage from '../pages/employer/staffs/ViewStaffPage';

// Vessels
import AddVesselPage from '../pages/settings/vessels/AddVesselPage';
import EditVesselPage from '../pages/settings/vessels/EditVesselPage';
import ListVesselPage from '../pages/settings/vessels/ListVesselPage';

// Signatures
// import ListSignaturePage from "../pages/settings/signatures/ListSignaturePage";
import EditSignaturePage from '../pages/settings/signatures/EditSignaturePage';

// Holidays
import AddHolidayPage from '../pages/settings/holidays/AddHolidayPage';
import EditHolidayPage from '../pages/settings/holidays/EditHolidayPage';
import ListHolidayPage from '../pages/settings/holidays/ListHolidayPage';
import ViewHolidayPage from '../pages/settings/holidays/ViewHolidayPage';

// Invoices
import AddInvoicePage from '../pages/finance/invoices/AddInvoicePage';
import EditInvoicePage from '../pages/finance/invoices/EditInvoicePage';
import ListInvoicePage from '../pages/finance/invoices/ListInvoicePage';
import ViewInvoicePage from '../pages/finance/invoices/ViewInvoicePage';
import ViewWorkInvoicePage from '../pages/finance/invoices/ViewInvoicePerWorkDonePage.vue';

// Invoice Items
import AddInvoiceItemPage from '../pages/finance/invoice_items/AddInvoiceItemPage';
import EditInvoiceItemPage from '../pages/finance/invoice_items/EditInvoiceItemPage';
import ListInvoiceItemPage from '../pages/finance/invoice_items/ListInvoiceItemPage';

// Status Items
import ListStatusOptionPage from '../pages/settings/StatusOptions/ListStatusOptionPage';
import ViewStatusOptionPage from '../pages/settings/StatusOptions/ViewStatusOptionPage';
import AddStatusOptionPage from '../pages/settings/StatusOptions/AddStatusOptionPage';
import EditStatusOptionPage from '../pages/settings/StatusOptions/EditStatusOptionPage';
import ListVendorUserPage from '../pages/Dashboard/Examples/UserManagement/ListVendorUserPage';

// Vouchers
import ViewVoucherPage from '../pages/finance/vouchers/ViewVoucherPage';
import ListVoucherPage from '../pages/finance/vouchers/ListVoucherPage';
import VoucherDashboardPage from '../pages/finance/vouchers/VoucherDashboardPage';


// Contributions
import ListContributionPage from '../pages/finance/contributions/ListContributionPage';
import ViewContributionPage from '../pages/finance/contributions/ViewContributionPage';
import AddContributionPage from '../pages/finance/contributions/AddContributionPage';
import EditContributionPage from '../pages/finance/contributions/EditContributionPage';

// Guidance Category
import AddGuidanceCategoryPage from '../pages/settings/guidances/guidanceCategory/AddGuidanceCategoryPage';
import EditGuidanceCategoryPage from '../pages/settings/guidances/guidanceCategory/EditGuidanceCategoryPage';
import ListGuidanceCategoryPage from '../pages/settings/guidances/guidanceCategory/ListGuidanceCategoryPage';

// Stations
import  ListSystemPage from '@/pages/settings/systems/ListSystemPage.vue';
import  EditSystemPage from '@/pages/settings/systems/EditSystemPage.vue';
import  AddSystemPage from '@/pages/settings/systems/AddSystemPage.vue';
import  ViewSystemPage from '@/pages/settings/systems/ViewSystemPage.vue';

// Biotime
import  ListBiotimeAreaPage from '@/pages/Biotime/Area/BiotimeAreaList.vue';
import  ViewBiotimeAreaPage from '@/pages/Biotime/Area/BiotimeAreaView.vue';
import  ListBiotimeAttendancePage from '@/pages/Biotime/Attendance/BiotimeAttendanceList.vue';
import  ViewBiotimeAttendancePage from '@/pages/Biotime/Attendance/BiotimeAttendanceView.vue';
import  ListBiotimeDevicePage from '@/pages/Biotime/Device/BiotimeDeviceList.vue';
import  ViewBiotimeDevicePage from '@/pages/Biotime/Device/BiotimeDeviceView.vue';
import  ListBiotimeSyncPage from '@/pages/Biotime/Sync/BiotimeSyncList.vue';
import  ViewBiotimeSyncPage from '@/pages/Biotime/Sync/BiotimeSyncView.vue';
import  BiometricWhitelistPage from '@/pages/Biotime/Whitelist/BiometricWhitelistPage.vue';
import  ListSmsLogePage from '@/pages/settings/sms/ListSmsLog.vue';
import SettingsPage from "@/pages/Utils/SettingsPage.vue";

let componentsMenu = {
    path: '/components',
    component: DashboardLayout,
    redirect: '/components/buttons',
    name: 'Components',
    children: [
        {
            path: 'buttons',
            name: 'Buttons',
            components: { default: Buttons },
            meta: { middleware: auth }
        },
        {
            path: 'grid-system',
            name: 'Grid System',
            components: { default: GridSystem },
            meta: { middleware: auth }
        },
        {
            path: 'panels',
            name: 'Panels',
            components: { default: Panels },
            meta: { middleware: auth }
        },
        {
            path: 'sweet-alert',
            name: 'Sweet Alert',
            components: { default: SweetAlert },
            meta: { middleware: auth }
        },
        {
            path: 'notifications',
            name: 'Notifications',
            components: { default: Notifications },
            meta: { middleware: auth }
        },
        {
            path: 'icons',
            name: 'Icons',
            components: { default: Icons },
            meta: { middleware: auth }
        },
        {
            path: 'typography',
            name: 'Typography',
            components: { default: Typography },
            meta: { middleware: auth }
        }
    ]
};


let vendorsMenu = {
    path: '/vendors',
    component: DashboardLayout,
    redirect: '/vendors/list-vendors',
    name: 'vendors',
    children: [
        {
            path: '/vendors/list-vendors',
            name: 'Vendors List',
            components: { default: ListVendorPage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/add-vendor',
            name: 'Add Vendor',
            components: { default: AddVendorPage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/edit-vendor/:id',
            name: 'Edit Vendor',
            components: { default: EditVendorPage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/view-vendor/:id',
            name: 'View Vendor',
            components: { default: ViewVendorPage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/add-employee',
            name: 'Add Employee',
            components: { default: AddEmployeePage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/edit-employee/:id',
            name: 'Edit Employee',
            components: { default: EditEmployeePage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/view-employee/:id',
            name: 'View Employee',
            components: { default: ViewEmployeePage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/list-employees',
            name: 'Employees List',
            components: { default:ListEmployeePage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/list-labourers',
            name: 'Labourers List',
            components: { default: ListLabourerPage },
            meta: { middleware: auth }
        },

        {
            path: '/vendors/list-labourers-terminated',
            name: 'List Labourer Terminated',
            components: { default: ListLabourerTerminatedPage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/upload-labourers',
            name: 'Labourers Upload',
            components: { default: UploadLabourerPage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/add-labourer',
            name: 'Add Labourer',
            components: { default: AddLabourerPage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/edit-labourer/:id',
            name: 'Edit Labourer',
            components: { default: EditLabourerPage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/view-labourer/:id',
            name: 'View Labourer',
            components: { default: ViewLabourerPage },
            meta: { middleware: auth,requiresAuth: true  }
        },
        {
            path: 'labourers/readiness',
            name: 'Labourer Readiness',
            components: { default: LabourerReadinessDashboard },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/list-labourer-attendances',
            name: 'Labourer Attendances List',
            components: { default: ListLabourerAttendancePage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/add-labourer-attendance',
            name: 'Add Labourer Attendance',
            components: { default: AddLabourerAttendancePage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/edit-labourer-attendance/:id',
            name: 'Edit Labourer Attendance',
            components: { default: EditLabourerAttendancePage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/view-labourer-attendance/:id',
            name: 'View Labourer Attendance',
            components: { default: ViewLabourerAttendancePage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/labourer-shift-report',
            name: 'Labourer Shift Report',
            components: { default: LabourerShiftReportPage },
            meta: { middleware: auth }
        },
        {
            path: 'vendors/view-labourer-schedule/:id',
            name: 'View Labourer Schedule',
            components: { default: ViewLabourerSchedulePage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/list-labourer-schedules',
            name: 'Labourer Schedules List',
            components: { default: ListLabourerSchedulePage },
            meta: { middleware: auth }
        },
        {
            path: '/vendors/labourer-takeon-search',
            name: 'Search Labourer Takeon',
            components: { default: ViewLabourerTakeonPage },
            meta: { middleware: auth }
        },
        {
            path: 'labourer/schedule/approve',
            name: 'Approve Labourer Schedule',
            components: { default: ApproveLabourerSchedulePage },
            meta: { middleware: auth }
        },
        {
            path: 'supervisor/checkin/checkout',
            name: 'Supervisor CheckIn CheckOut',
            components: { default: SupervisorCheckinCheckout },
            meta: { middleware: auth }
        },
    ]
};

let examplesMenu = {
    path: '/clms',
    component: DashboardLayout,
    name: 'Examples',
    children: [
        {
            path: 'user-profile',
            name: 'User Profile',
            components: { default: UserProfile },
            meta: { middleware: auth }
        },
        {
            path: 'role-management/list-roles',
            name: 'List Roles',
            components: { default: ListRolePage },
            meta: { middleware: auth }
        },
        {
            path: 'role-management/add-role',
            name: 'Add Role',
            components: { default: AddRolePage },
            meta: { middleware: auth }
        },
        {
            path: 'role-management/edit-role/:id',
            name: 'Edit Role',
            components: { default: EditRolePage },
            meta: { middleware: auth }
        },
        {
            path: 'role-management/view-role/:id',
            name: 'View Role',
            components: { default: ViewRolePage },
            meta: { middleware: auth }
        },
        {
            path: 'role-management/assign-permission',
            name: 'Assign Permission',
            components: { default: AssignPermissionPage },
            meta: { middleware: auth }
        },
        {
            path: 'user-management/list-users',
            name: 'List Users',
            components: { default: ListUserPage },
            meta: { middleware: auth }
        },
        {
            path: 'user-management/vendor-users',
            name: 'List Vendor Users',
            components: { default: ListVendorUserPage },
            meta: { middleware: auth }
        },
        {
            path: 'user-management/view-user/:id',
            name: 'View User',
            components: { default: ViewUserPage },
            meta: { middleware: auth }
        },
        // {
        //   path: "user-management/add-user",
        //   name: "Add User",
        //   components: { default: AddUserPage },
        //   meta: { middleware: auth }
        // },
        {
            path: 'user-management/edit-user/:id',
            name: 'Edit User',
            components: { default: EditUserPage },
            meta: { middleware: auth }
        },
        {
            path: 'category-management/list-categories',
            name: 'List Categories',
            components: { default: ListCategoryPage },
            meta: { middleware: auth }
        },
        {
            path: 'category-management/add-category',
            name: 'Add Category',
            components: { default: AddCategoryPage },
            meta: { middleware: auth }
        },
        {
            path: 'category-management/edit-category/:id',
            name: 'Edit Category',
            components: { default: EditCategoryPage },
            meta: { middleware: auth }
        },
        {
            path: 'tag-management/list-tags',
            name: 'List Tags',
            components: { default: ListTagPage },
            meta: { middleware: auth }
        },
        {
            path: 'tag-management/add-tag',
            name: 'Add Tag',
            components: { default: AddTagPage },
            meta: { middleware: auth }
        },
        {
            path: 'tag-management/edit-tag/:id',
            name: 'Edit Tag',
            components: { default: EditTagPage },
            meta: { middleware: auth }
        },
        {
            path: 'item-management/list-items',
            name: 'List Items',
            components: { default: ListItemPage },
            meta: { middleware: auth }
        },
        {
            path: 'item-management/add-item',
            name: 'Add Item',
            components: { default: AddItemPage },
            meta: { middleware: auth }
        },
        {
            path: 'item-management/edit-item/:id',
            name: 'Edit Item',
            components: { default: EditItemPage },
            meta: { middleware: auth }
        },
    ]
};
// added menu for testings
let settingMenu = {
    path: '/settings',
    component: DashboardLayout,
    redirect: '/setting/list-stations',
    name: 'settings',
    children: [
        {
            path: 'setting/list-stations',
            name: 'Stations List',
            components: { default: ListStationPage },
            meta: { middleware: auth }
        },
        {
            path: 'sms/logs',
            name: 'Sms Logs',
            components: { default: ListSmsLogePage },
            meta: { middleware: auth }
        },
        {
            path: 'schedule',
            name: 'Settings Schedule',
            components: { default: SettingsPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/add-station',
            name: 'Add Station',
            components: { default: AddStationPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/edit-station/:id',
            name: 'Edit Station',
            components: { default: EditStationPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/view-station/:id',
            name: 'view Station',
            components: { default: ViewStationPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/list-departments',
            name: 'Departments List',
            components: { default: ListDepartmentPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/add-department',
            name: 'Add Department',
            components: { default: AddDepartmentPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/edit-department/:id',
            name: 'Edit Department',
            components: { default: EditDepartmentPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/view-department/:id',
            name: 'view Department',
            components: { default: ViewDepartmentPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/list-ports',
            name: 'Ports List',
            components: { default: ListPortPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/add-port',
            name: 'Add Port',
            components: { default: AddPortPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/edit-port/:id',
            name: 'Edit Port',
            components: { default: EditPortPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/view-port/:id',
            name: 'view Port',
            components: { default: ViewPortPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/list-workplaces',
            name: 'Workplaces List',
            components: { default: ListWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/add-workplace',
            name: 'Add Workplace',
            components: { default: AddWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/edit-workplace/:id',
            name: 'Edit Workplace',
            components: { default: EditWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/view-workplace/:id',
            name: 'View Workplace',
            components: { default: ViewWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: 'list-activities',
            name: 'Activities List',
            components: { default: ListActivityPage },
            meta: { middleware: auth }
        },
        {
            path: 'add-activity',
            name: 'Add Activity',
            components: { default: AddActivityPage },
            meta: { middleware: auth }
        },
        {
            path: 'edit-activity/:id',
            name: 'Edit Activity',
            components: { default: EditActivityPage },
            meta: { middleware: auth }
        },
        {
            path: 'view-activity/:id',
            name: 'View Activity',
            components: { default: ViewActivityPage },
            meta: { middleware: auth }
        },
        {
            path: 'list-guidances',
            name: 'Guidances List',
            components: { default: ListGuidancePage },
            meta: { middleware: auth }
        },
        {
            path: 'manage-guidance-shift/:id',
            name: 'Manage Guidance Item',
            components: { default: ManageGuidanceShiftPage },
            meta: { middleware: auth }
        },
        {
            path: 'manage-guidance-work-item/:id',
            name: 'Manage Guidance Work Item',
            components: { default: ManageGuidanceWorkItemtPage },
            meta: { middleware: auth }
        },
        {
            path: 'action-guidance-work-item/:id',
            name: 'Action Guidance Work Item',
            components: { default: ActionGuidanceWorkItemtPage },
            meta: { middleware: auth }
        },
        {
            path: 'manage-guidance-item/:id',
            name: 'Manage Guidance Shift',
            components: { default: ManageGuidancePage },
            meta: { middleware: auth }
        },
        {
            path: 'guidance-labourer-assignment/:id',
            name: 'Guidance Labour Assignment',
            components: { default: ManageLabourerAssignmentPage },
            meta: { middleware: auth }
        },
        {
            path: 'add-guidance',
            name: 'Add Guidance',
            components: { default: AddGuidancePage },
            meta: { middleware: auth }
        },
        {
            path: ':id/edit-guidance/',
            name: 'Edit Guidance',
            components: { default: EditGuidancePage },
            meta: { middleware: auth }
        },
        {
            path: 'view-guidance/:id',
            name: 'View Guidance',
            components: { default: ViewGuidancePage },
            meta: { middleware: auth }
        },
        {
            path: 'list-activityGuidances',
            name: 'Activity Guidances List',
            components: { default: ListActivityGuidancePage },
            meta: { middleware: auth }
        },
        {
            path: 'edit-activity-guidance/:id',
            name: 'Edit Activity Guidance',
            components: { default: EditActivityGuidancePage },
            meta: { middleware: auth }
        },
        {
            path: 'list-activityTariffs',
            name: 'Activity Tariffs List',
            components: { default: ListActivityTariffPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/list-shifts',
            name: 'Shifts List',
            components: { default: ListShiftPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/add-shift',
            name: 'Add Shift',
            components: { default: AddShiftPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/edit-shift/:id',
            name: 'Edit Shift',
            components: { default: EditShiftPage },
            meta: { middleware: auth }
        },
        {
            path: 'setting/view-shift/:id',
            name: 'View Shift',
            components: { default: ViewShiftPage },
            meta: { middleware: auth }
        },
        {
            path: 'add-activityGuidances',
            name: 'Add Activity Guidance',
            components: { default: AddActivityGuidancePage },
            meta: { middleware: auth }
        },
        {
            path: '/setting/add-permission',
            name: 'Add Permission',
            components: { default: AddPermissionPage },
            meta: { middleware: auth }
        },
        {
            path: '/setting/edit-permission/:id',
            name: 'Edit Permission',
            components: { default: EditPermissionPage },
            meta: { middleware: auth }
        },
        {
            path: '/setting/list-permissions',
            name: 'List Permissions',
            components: { default: ListPermissionPage },
            meta: { middleware: auth }
        },
        {
            path: 'guidances-workplace/add',
            name: 'Add Workplace to Guidance',
            components: { default: AddGuidanceWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: 'guidances-workplace/view',
            name: 'View Guidance Workplace',
            components: { default: ViewGuidanceWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: 'guidances-workplace/edit/:id',
            name: 'Edit Guidance Workplace',
            components: { default: EditGuidanceWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: 'list-guidances-workplace',
            name: 'Guidance Workplaces List',
            components: { default: ListGuidanceWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: '/setting/add-zone',
            name: 'Add Zone',
            components: { default: AddZonePage },
            meta: { middleware: auth }
        },
        {
            path: '/setting/edit-zone/:id',
            name: 'Edit Zone',
            components: { default: EditZonePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-zones',
            name: 'Zones List',
            components: { default: ListZonePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-region',
            name: 'Add Region',
            components: { default: AddRegionPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-region/:id',
            name: 'Edit Region',
            components: { default: EditRegionPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-regions',
            name: 'Regions List',
            components: { default: ListRegionPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-religion',
            name: 'Add Religion',
            components: { default: AddReligionPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-religion/:id',
            name: 'Edit Religion',
            components: { default: EditReligionPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-religions',
            name: 'Religions List',
            components: { default: ListReligionPage },
            meta: { middleware: auth }
        },

        {
            path: '/setting/add-district-type',
            name: 'Add District Type',
            components: { default: AddDistrictTypePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-district-type/:id',
            name: 'Edit District Type',
            components: { default: EditDistrictTypePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-district-types',
            name: 'District Types List',
            components: { default: ListDistrictTypePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-district',
            name: 'Add District',
            components: { default: AddDistrictPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-district/:id',
            name: 'Edit District',
            components: { default: EditDistrictPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-districts',
            name: 'Districts List',
            components: { default: ListDistrictPage },
            meta: { middleware: auth }
        },
        {
            path: '/setting/add-ward',
            name: 'Add Ward',
            components: { default: AddWardPage },
            meta: { middleware: auth }
        },
        {
            path: '/setting/edit-ward/:id',
            name: 'Edit Ward',
            components: { default: EditWardPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-wards',
            name: 'Wards List',
            components: { default:ListWardPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-village',
            name: 'Add Village',
            components: { default: AddVillagePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-village/:id',
            name: 'Edit Village',
            components: { default: EditVillagePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-villages',
            name: 'Villages List',
            components: { default:ListVillagePage },
            meta: { middleware: auth }
        },


        {
            path: '/settings/add-neighborhood',
            name: 'Add Neighborhood',
            components: { default: AddNeighborhoodPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-neighborhood/:id',
            name: 'Edit Neighborhood',
            components: { default: EditNeighborhoodPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-neighborhoods',
            name: 'Neighborhoods List',
            components: { default:ListNeighborhoodPage },
            meta: { middleware: auth }
        },

        {
            path: '/settings/add-exam-cycle',
            name: 'Add Exam Cycle',
            components: { default: AddexamCyclePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-exam-cycle/:id',
            name: 'Edit Exam Cycle',
            components: { default: EditexamCylePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-exam-cycles',
            name: 'Exam Cycle List',
            components: { default:ListexamCyclePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-skill',
            name: 'Add Skill',
            components: { default: AddSkillPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-skill/:id',
            name: 'Edit Skill',
            components: { default: EditSkillPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/view-skill/:id',
            name: 'View Skill',
            components: { default: ViewSkillPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-skills',
            name: 'Skills List',
            components: { default:ListSkillPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-level',
            name: 'Add Level',
            components: { default: AddLevelPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-level/:id',
            name: 'Edit Level',
            components: { default: EditLevelPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-levels',
            name: 'Levels List',
            components: { default:ListLevelPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-skill-category',
            name: 'Add Skill Category',
            components: { default: AddSkillCategoryPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-skill-category/:id',
            name: 'Edit Skill Category',
            components: { default: EditSkillCategoryPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-skills-categories',
            name: 'Skills Categories List',
            components: { default:ListSkillCategoryPage },
            meta: { middleware: auth }
        },

        {
            path: '/settings/add-attachment-type',
            name: 'Add Attachment Type',
            components: { default: AddAttachmentTypesPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-attachment-type/:id',
            name: 'Edit Attachment Type',
            components: { default: EditAttachmentTypesPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-attachment-types',
            name: 'Attachments Types List',
            components: { default:ListAttachmentTypePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-vessels',
            name: 'Vessels List',
            components: { default:ListVesselPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-vessel',
            name: 'Add Vessel',
            components: { default: AddVesselPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-vessel/:id',
            name: 'Edit Vessel',
            components: { default: EditVesselPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-holiday',
            name: 'Add Holiday',
            components: { default: AddHolidayPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-holiday/:id',
            name: 'Edit Holiday',
            components: { default: EditHolidayPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-holidays',
            name: 'Holidays List',
            components: { default:ListHolidayPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/view-holiday',
            name: 'View Holiday',
            components: { default:ViewHolidayPage },
            meta: { middleware: auth }
        },
        {
            path: 'status/options/list',
            name: 'List Status Options',
            components: { default: ListStatusOptionPage },
            meta: { middleware: auth }
        },
        {
            path: 'status/options/edit',
            name: 'Edit Status Option',
            components: { default: EditStatusOptionPage },
            meta: { middleware: auth }
        },
        {
            path: 'status/options/add',
            name: 'Add Status Option',
            components: { default: AddStatusOptionPage },
            meta: { middleware: auth }
        },
        {
            path: 'status/options/view',
            name: 'View Status Option',
            components: { default: ViewStatusOptionPage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/voucher/lists',
            name: 'List Utilization Sheet Summary',
            components: { default: ListVoucherPage },
            meta: { middleware: auth }
        },
        {
            path: '/vouchers/dashboard',
            name: 'VoucherDashboard',
            component: { default: VoucherDashboardPage },
        },
        {
            path: '/voucher/view-voucher/:id',
            name: 'View Utilization Sheet Summary',
            components: { default: ViewVoucherPage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/contribution/lists',
            name: 'List Contributions',
            components: { default: ListContributionPage },
            meta: { middleware: auth }
        },
        {
            path: '/contribution/view-contribution/:id',
            name: 'View Contribution',
            components: { default: ViewContributionPage },
            meta: { middleware: auth }
        },
        {
            path: '/contribution/add-contribution',
            name: 'Add Contribution',
            components: { default: AddContributionPage },
            meta: { middleware: auth }
        },
        {
            path: '/contribution/edit/:id',
            name: 'Edit Contribution',
            components: { default: EditContributionPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/add-guidance-category',
            name: 'Add Guidance Category',
            components: { default: AddGuidanceCategoryPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/edit-guidance-category/:id',
            name: 'Edit Guidance Category',
            components: { default: EditGuidanceCategoryPage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/list-guidance-categories',
            name: 'Guidance Categories List',
            components: { default:ListGuidanceCategoryPage },
            meta: { middleware: auth }
        },
        // ================= Activity Labourer Workplace ======================
        {
            path: '/settings/activity/labourer/workplace/add',
            name: 'Add Activity Labourer Workplace',
            components: { default: AddActivityLabourerWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/activity/labourer/workplace/edit/:id',
            name: 'Edit Activity Labourer Workplace',
            components: { default: EditActivityLabourerWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/activity/labourer/workplace',
            name: 'List Activity Labourer Workplace',
            components: { default:ListActivityLabourerWorkplacePage },
            meta: { middleware: auth }
        },
        {
            path: '/settings/activity/labourer/view:id',
            name: 'View Activity Labourer Workplace',
            components: { default:ViewActivityLabourerWorkplacePage },
            meta: { middleware: auth }
        },
        // ================= Activity Labourer Workplace ======================

    ]
};

let clientsMenu = {
    path: '/settings/clients',
    component: DashboardLayout,
    redirect: '/settings/clients',
    name: 'Clients',
    children: [
        {
            path: 'list',
            name: 'List Client',
            components: { default: ListSystemPage },
            meta: { middleware: auth }
        },
        {
            path: 'view/:id',
            name: 'View Client',
            components: { default: ViewSystemPage },
            meta: { middleware: auth }
        },
        {
            path: 'edit/:id',
            name: 'Edit Client',
            components: { default: EditSystemPage },
            meta: { middleware: auth }
        },
        {
            path: 'add',
            name: 'Add Client',
            components: { default: AddSystemPage },
            meta: { middleware: auth }
        },
    ]
};



let employerMenu = {
    path: '/employer',
    component: DashboardLayout,
    redirect: '/employers/list-tariffs',
    name: 'tariffs',
    children: [
        {
            path: '/labourer/payments',
            name: 'Labourer Payments',
            components: { default: LabourerPayments },
            meta: { middleware: auth }
        },
        {
            path: '/labourer/payment/ready',
            name: 'Ready Labourer Payments',
            components: { default: LabourerPaymentsReady },
            meta: { middleware: auth }
        },


        {
            path: 'employer/list-tariffs',
            name: 'Tariffs List',
            components: { default: ListTariffPage },
            meta: { middleware: auth }
        },
        {
            path: 'employer/add-tariff',
            name: 'Add Tariff',
            components: { default: AddTariffPage },
            meta: { middleware: auth }
        },
        {
            path: 'employer/edit-tariff/:id',
            name: 'Edit Tariff',
            components: { default: EditTariffPage },
            meta: { middleware: auth }
        },
        {
            path: 'employer/view-tariff/:id',
            name: 'View Tariff',
            components: { default: ViewTariffPage },
            meta: { middleware: auth }
        },


        {
            path: '/labourer/payment/list',
            name: 'List Labourer Payment',
            components: { default: ListLabourerPaymentPage },
            meta: { middleware: auth }
        },
        {
            path: '/labourer/payment/add',
            name: 'Add Labourer Payment',
            components: { default: AddLabourerPaymentPage },
            meta: { middleware: auth }
        },
        {
            path: '/labourer/payment/edit/:id',
            name: 'Edit Labourer Payment',
            components: { default: EditLabourerPaymentPage },
            meta: { middleware: auth }
        },
        {
            path: '/labourer/payment/view/:id',
            name: 'View Labourer Payment',
            components: { default: ViewLabourerPaymentPage },
            meta: { middleware: auth }
        },


        {
            path: '/labourer/payment/item/list',
            name: 'List Labourer Payment Item',
            components: { default: ListLabourerPaymentItemPage },
            meta: { middleware: auth }
        },
        {
            path: '/labourer/payment/item/add',
            name: 'Add Labourer Payment Item',
            components: { default: AddLabourerPaymentItemPage },
            meta: { middleware: auth }
        },
        {
            path: '/labourer/payment/item/edit/:id',
            name: 'Edit Labourer Payment Item',
            components: { default: EditLabourerPaymentItemPage },
            meta: { middleware: auth }
        },
        {
            path: '/labourer/payment/item/view/:id',
            name: 'View Labourer Payment Item',
            components: { default: ViewLabourerPaymentItemPage },
            meta: { middleware: auth }
        },




        {
            path: '/employer/add-institution',
            name: 'Add Institution',
            components: { default: AddInstitutionPage },
            meta: { middleware: auth }
        },
        {
            path: '/employer/edit-institution/:id',
            name: 'Edit Institution',
            components: { default: EditInstitutionPage },
            meta: { middleware: auth }
        },
        {
            path: '/employer/view-institution/:id',
            name: 'View Institution',
            components: { default: ViewInstitutionPage },
            meta: { middleware: auth }
        },
        {
            path: '/employer/list-institutions',
            name: 'Institutions List',
            components: { default:ListInstitutionPage },
            meta: { middleware: auth }
        },
        {
            path: '/employer/add-staff',
            name: 'Add Staff',
            components: { default: AddStaffPage },
            meta: { middleware: auth }
        },
        {
            path: '/employer/edit-staff/:id',
            name: 'Edit Staff',
            components: { default: EditStaffPage },
            meta: { middleware: auth }
        },
        {
            path: '/employer/view-staff/:id',
            name: 'View Staff',
            components: { default: ViewStaffPage },
            meta: { middleware: auth }
        },
        {
            path: '/employer/list-staffs',
            name: 'Staffs List',
            components: { default:ListStaffPage },
            meta: { middleware: auth }
        },
        {
            path: 'list-works',
            name: 'Works List',
            components: { default: ListWorkPage },
            meta: { middleware: auth }
        },
        {
            path: 'add-work',
            name: 'Add Work',
            components: { default: AddWorkPage },
            meta: { middleware: auth }
        },
        {
            path: 'edit-work/:id',
            name: 'Edit Work',
            components: { default: EditWorkPage },
            meta: { middleware: auth }
        },
        {
            path: 'view-work/:id',
            name: 'View Work',
            components: { default: ViewWorkPage },
            meta: { middleware: auth }
        },
        {
            path: 'list-workItems',
            name: 'Work Items List',
            components: { default: ListWorkItemPage },
            meta: { middleware: auth }
        },
        {
            path: 'add-workItems',
            name: 'Add Work Item',
            components: { default: AddWorkItemPage },
            meta: { middleware: auth }
        },
        {
            path: 'edit-workItem/:id',
            name: 'Edit Work Item',
            components: { default: EditWorkItemPage },
            meta: { middleware: auth }
        },
        {
            path: 'list-workDetails',
            name: 'Work Details List',
            components: { default: ListWorkDetailPage },
            meta: { middleware: auth }
        },
        {
            path: 'add-workDetails',
            name: 'Add Work Detail',
            components: { default: AddWorkDetailPage },
            meta: { middleware: auth }
        },
        {
            path: 'edit-workDetail/:id',
            name: 'Edit Work Detail',
            components: { default: EditWorkDetailPage },
            meta: { middleware: auth }
        },

        {
            path: '/approval-wizard/:id',
            name: 'Approval Wizard',
            components: { default: AddApprovalFormWizard },
            meta: { middleware: auth }
        },
        {
            path: '/settings/signatures/edit-signature/:id',
            name: 'Edit Signature',
            components: { default: EditSignaturePage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/list-invoices',
            name: 'Utilization Sheet List',
            components: { default:ListInvoicePage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/add-invoice',
            name: 'Add Utilization Sheet',
            components: { default: AddInvoicePage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/edit-invoice/:id',
            name: 'Edit Utilization Sheet',
            components: { default: EditInvoicePage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/view-invoice/:id',
            name: 'View Utilization Sheet',
            components: { default: ViewInvoicePage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/view-invoice/work/:id',
            name: 'View Work Utilization Sheet',
            components: { default: ViewWorkInvoicePage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/list-invoice-items',
            name: 'Invoice Items List',
            components: { default:ListInvoiceItemPage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/add-invoice-item',
            name: 'Add Invoice Item',
            components: { default: AddInvoiceItemPage },
            meta: { middleware: auth }
        },
        {
            path: '/finance/edit-invoice-item/:id',
            name: 'Edit Invoice Item',
            components: { default: EditInvoiceItemPage },
            meta: { middleware: auth }
        },
    ],
};

let mapsMenu = {
    path: '/maps',
    component: DashboardLayout,
    name: 'Maps',
    redirect: '/maps/google',
    children: [
        {
            path: 'google',
            name: 'Google Maps',
            components: { default: GoogleMaps },
            meta: { middleware: auth }
        },
        {
            path: 'full-screen',
            name: 'Full Screen Map',
            meta: {
                hideContent: true,
                hideFooter: true,
                navbarAbsolute: true,
                middleware: auth
            },
            components: { default: FullScreenMap }
        },
        {
            path: 'vector-map',
            name: 'Vector Map',
            components: { default: VectorMaps },
            meta: { middleware: auth }
        }
    ]
};

let pagesMenu = {
    path: '/pages',
    component: DashboardLayout,
    name: 'Pages',
    redirect: '/pages/user',
    children: [
        {
            path: 'user',
            name: 'User Page',
            components: { default: User },
            meta: { middleware: auth }
        },
        {
            path: 'timeline',
            name: 'Timeline Page',
            components: { default: TimeLine },
            meta: { middleware: auth }
        },
    ]
};

let authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: { middleware: guest },
        },{
            path: '/labourer/info/search',
            name: 'LabourerInfoSearch',
            component: LabourerInfoSearch,
            meta: { middleware: guest },
        },
        {
            path: '/reset',
            name: 'Reset',
            component: PasswordReset,
            meta: { middleware: guest }
        },
        {
            path: '/reset-process',
            name: 'Reset Password',
            component: Reset,
            meta: { middleware: guest }
        },

        {
            path: '/register',
            name: 'Register',
            component: Register,
            meta: { middleware: guest }
        },
        {
            path: '/lock',
            name: 'Lock',
            component: Lock
        }
    ]
};

let biotimeMenu = {
    path: '/biotime',
    component: DashboardLayout,
    name: 'Biotime',
    children: [
        {
            path: 'attendance',
            name: 'Biotime Attendance',
            component: ListBiotimeAttendancePage,
            meta: { middleware: auth },
        },
        {
            path: 'attendance/view/:id',
            name: 'Biotime Attendance View',
            component: ViewBiotimeAttendancePage,
            meta: { middleware: auth },
        },
        {
            path: 'device',
            name: 'Biotime Device',
            component: ListBiotimeDevicePage,
            meta: { middleware: auth },
        },
        {
            path: 'device/view/:id',
            name: 'Biotime Device View',
            component: ViewBiotimeDevicePage,
            meta: { middleware: auth },
        },
        {
            path: 'area',
            name: 'Biotime Area',
            component: ListBiotimeAreaPage,
            meta: { middleware: auth },
        },
        {
            path: 'area/view/:id',
            name: 'Biotime Area View',
            component: ViewBiotimeAreaPage,
            meta: { middleware: auth },
        },
        {
            path: 'sync',
            name: 'Biotime Sync',
            component: ListBiotimeSyncPage,
            meta: { middleware: auth },
        },
        {
            path: 'sync/view/:id',
            name: 'Biotime Sync View',
            component: ViewBiotimeSyncPage,
            meta: { middleware: auth },
        },
        {
            path: 'whitelist/list',
            name: 'Biometric Whitelist',
            component: BiometricWhitelistPage,
            meta: { middleware: auth },
        },
    ]
};

const routes = [
    {
        path: '/',
        redirect: '/dashboard',
        name: 'Home',
        meta: { middleware: auth }
    },
    componentsMenu,
    examplesMenu,
    vendorsMenu,
    settingMenu,
    clientsMenu,
    mapsMenu,
    pagesMenu,
    employerMenu,
    biotimeMenu,
    authPages,
    {
        path: '/',
        component: DashboardLayout,
        meta: { middleware: auth },
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                components: { default: Dashboard },
                meta: { middleware: auth }
            },
            {
                path: 'today',
                name: 'TodayDashboard',
                components: { default: TodayDashboard },
                meta: { middleware: auth }
            },
            {
                path: 'calendar',
                name: 'Calendar',
                components: { default: Calendar },
                meta: { middleware: auth }
            },
            {
                path: 'charts',
                name: 'Charts',
                components: { default: Charts },
                meta: { middleware: auth }
            },
            {
                path: 'widgets',
                name: 'Widgets',
                components: { default: Widgets },
                meta: { middleware: auth }
            }
        ]
    }
];

export default routes;
